var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcBack = function SvgIcBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_back")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_back",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5506321,0.449367923 C15.112342,1.01107783 15.1474488,1.89997691 14.6559527,2.50258546 L14.5506321,2.61910819 L6.04094681,11.125 L23.5,11.125 C24.2593915,11.125 24.875,11.7406085 24.875,12.5 C24.875,13.2147214 24.3296859,13.802078 23.6324217,13.8687056 L23.5,13.875 L6.04294681,13.875 L14.5506321,22.3808918 C15.1497893,22.980049 15.1497893,23.9514748 14.5506321,24.5506321 C13.9914187,25.1098455 13.107918,25.1471264 12.5054662,24.6624748 L12.3808918,24.5506321 L0.262946812,12.4326871 L12.3808918,0.449367923 L12.5054662,0.33752524 C13.107918,-0.147126387 13.9914187,-0.109845492 14.5506321,0.449367923 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_back.9cb33150.svg";
export { ForwardRef as ReactComponent };